<template>
  <section class="contest-step4">
    <div class="step1" v-if="!hasPay">
      <ul class="show-list">
        <li>
          <span class="title">{{$t('global.总计')}}</span>
          <div>
            <b>{{price|numToPrice}}</b>
            <span>{{$t('global.参赛作品评选费基本费用')}}，{{$t('global.不包含展示费和得奖者服务费')}}</span>
          </div>
        </li>
        <li>
          <span class="title">{{$t('global.支付方式')}}</span>
          <div>
            <el-radio-group v-model="payType">
              <el-radio :label="0">
                <img src="/static/match/images/alipay.png" alt />
              </el-radio>
              <el-radio :label="3">
                <img src="/static/match/images/paypal.png" alt />
              </el-radio>
              <el-radio :label="4">{{$t('global.线下支付')}}</el-radio>
            </el-radio-group>
            <div class="xianxia" v-if="payType === 4">
              <p>{{$t('global.转账请备注')}}：{{$t('global.注册邮箱')}} + {{$t('global.参赛方')}} + {{$t('global.转账人')}} + {{$t('global.手机')}}，{{$t('global.作为报名支付成功的唯一凭证')}}</p>
              <div class="bankList">
                <div class="bank">
                  <img src="/static/match/images/icbc.png" alt />
                  <span>{{$t('global.户名')}}：上海成功商务服务有限公司</span>
                  <span>{{$t('global.开户行')}}：工行静安支行</span>
                  <span>{{$t('global.账号')}}：1001211309207989444</span>
                </div>
                <div class="bank">
                  <img src="/static/match/images/hsbc.png" alt />
                  <span>{{$t('global.外币')}}：ICBKCNBJSHI</span>
                  <span>{{$t('global.人民币')}}：102290021133</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <span class="title">
           {{ $t('global.开具发票')}}
            <el-checkbox-group v-model="isInvoice">
              <el-checkbox name="isInvoice"></el-checkbox>
            </el-checkbox-group>
          </span>
          <div v-if="isInvoice">
            <el-radio-group v-model="type">
              <el-radio :label="0">{{$t('global.普通发票')}}</el-radio>
              <el-radio :label="1">{{$t('global.专用发票')}}</el-radio>
            </el-radio-group>
          </div>
        </li>
      </ul>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        class="form"
        v-if="isInvoice"
      >
        <el-form-item :label="$t('global.发票抬头')" prop="invoiceTitle">
          <el-input v-model="form.invoiceTitle"></el-input>
        </el-form-item>

        <el-form-item :label="$t('global.发票税号')" prop="invoiceCode" v-if="type === 1">
          <el-input v-model="form.invoiceCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.开户行')" prop="openingBank" v-if="type === 1">
          <el-input v-model="form.openingBank"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.账号')" prop="accountNumber" v-if="type === 1">
          <el-input v-model="form.accountNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.公司地址')" prop="companyAddress" v-if="type === 1">
          <el-input v-model="form.companyAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.公司电话')" prop="companyPhone" v-if="type === 1">
          <el-input v-model="form.companyPhone"></el-input>
        </el-form-item>

        <el-form-item :label="$t('global.收件人地址')" prop="recipientAddress">
          <el-input v-model="form.recipientAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.收件人电话')" prop="recipientPhone">
          <el-input v-model="form.recipientPhone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('global.收件人姓名')" prop="recipientName">
          <el-input v-model="form.recipientName"></el-input>
        </el-form-item>
        <el-form-item>
          <p class="notice">
            {{$t('global.备注')}}：
            <br />{{$t('global.开票内容为报名费')}}，{{$t('global.发票快递为到付')}}。
            <br />{{$t('global.报名支付如有问题')}}，{{$t('global.请联系')}}021-52998050
          </p>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="close">{{$t('global.取 消')}}</el-button>
        <el-button type="primary" @click="submit">{{payType===4?$t('global.提交'):$t('global.去支付')}}</el-button>
      </div>
    </div>
    <div class="hasPay" v-else>
      <img src="/static/match/images/success.png" alt />
      <h4>{{$t('global.恭喜你')}}，{{$t('global.提交成功')}}！</h4>
      <p v-if="payType === 4">
        {{$t('global.请于3个工作日内完成线下支付')}}
        <br />{{$t('global.支付完成审核后即为投稿成功')}}
      </p>
    </div>
  </section>
</template>

<script>
import axios from "axios";
const pingpp = require("pingpp-js");
export default {
  data() {
    return {
      hasPay: false,
      form: {
        invoiceTitle: "",
        recipientAddress: "",
        recipientPhone: "",
        recipientName: "",
        invoiceCode: undefined,
        openingBank: undefined,
        accountNumber: undefined,
        companyAddress: undefined,
        companyPhone: undefined
      },
      rules: {
        invoiceTitle: [
          { required: true, message: this.$t('global.请填写发票抬头'), trigger: "blur" }
        ],
        recipientAddress: [
          { required: true, message: this.$t('global.请填写收件人地址'), trigger: "blur" }
        ],
        recipientPhone: [
          { required: true, message: this.$t('global.请填写收件人电话'), trigger: "blur" }
        ],
        recipientName: [
          { required: true, message: this.$t('global.请填写收件人姓名'), trigger: "blur" }
        ],
        invoiceCode: [
          { required: true, message: this.$t('global.请填写发票税号'), trigger: "blur" }
        ],
        openingBank: [
          { required: true, message: this.$t('global.请填写开户行'), trigger: "blur" }
        ],
        accountNumber: [
          { required: true, message: this.$t('global.请填写账号'), trigger: "blur" }
        ],
        companyAddress: [
          { required: true, message: this.$t('global.请填写公司地址'), trigger: "blur" }
        ],
        companyPhone: [
          { required: true, message: this.$t('global.请填写公司电话'), trigger: "blur" }
        ]
      },
      payType: 0,
      type: 0,
      isInvoice: false
    };
  },
  props: ["price", "videoId"],
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$query.videoId) {
        this.getInfo(this.$query.videoId);
      }
      if (
        this.$query.trade_status === "TRADE_SUCCESS" &&
        this.$query.out_trade_no
      ) {
        this.updateStatus(this.$query.out_trade_no);
      } else if (this.$query.state === "payed" && this.$query.orderNo) {
        this.updateStatus(this.$query.orderNo);
      }
    },
    updateStatus(recordNo) {
      const url = `/api/match/pay/updateStatus`;
      const params = {
        matchUrl: this.$route.params.contestName,
        videoId: this.$query.videoId,
        recordNo: recordNo
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          if (res.data.isPay === 0 || res.data.status === 0) {
            this.hasPay = true;
            this.payType = res.data.payType;
          }
        }
      });
    },
    getInfo(videoId) {
      const url = `/api/match/pay/getMatchPayRecord`;
      const params = {
        videoId: videoId,
        matchUrl: this.$route.params.contestName
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          const data = res.data;
          this.payType = +data.payType;
          this.type = data.type;
          this.isInvoice = data.isInvoice;
          this.hasPay = data.status === 0;
          this.form = {
            invoiceTitle: data.invoiceTitle,
            recipientAddress: data.recipientAddress,
            recipientPhone: data.recipientPhone,
            recipientName: data.recipientName,
            invoiceCode: data.invoiceCode,
            openingBank: data.openingBank,
            accountNumber: data.accountNumber,
            companyAddress: data.companyAddress,
            companyPhone: data.companyPhone
          };
        }
      });
    },
    async submit() {
      if (!this.payType && this.payType !== 0) {
        this.$message.error(this.$t('global.请选择支付方式'));
        return;
      }
      if (this.$refs.form) {
        this.$refs.form.validate(async valid => {
          if (valid) {
            if (this.payType === 0 || this.payType === 3) {
              this.pay();
            }
            if (this.payType === 4) {
              await this.creatPayInfo();
              this.hasPay = true;
            }
          }
        });
      } else {
        if (this.payType === 0 || this.payType === 3) {
          this.pay();
        }
        if (this.payType === 4) {
          await this.creatPayInfo();
          this.hasPay = true;
        }
      }
    },
    close() {
      this.$router.back();
    },
    pay() {
      const backUrl = `${window.location.origin}/match/${this.$route.params.contestName}/enter?videoId=${this.videoId}%26step=4`;
      const params = {
        channel: !this.payType ? "alipay_pc_direct" : "paypal", // alipay_pc_direct, alipay_wap, paypal
        email: this.$store.state.peopleMessage.email, // 用户邮箱
        success_url: backUrl, // 成功回调地址
        cancel_url: backUrl, // 取消回调地址
        feeCount: 1 
      };
      // const url = `http://successfuldesign.org/mana/pay`;
      const url = `/mana/pay`;
      axios.post(url, params).then(res => {
        const data = res.data;
        if (data.code === 0) {
          if (data.charge) {
            pingpp.createPayment(data.charge, function() {});
          } else if (data.link) {
            location.assign(data.link);
          }
          this.creatPayInfo(data.orderNo);
        }
      });
    },
    creatPayInfo(orderNo) {
      const url = `/api/match/pay/create`;
      let params = {
        isInvoice: this.isInvoice,
        payType: this.payType,
        matchUrl: this.$route.params.contestName,
        videoId: this.videoId
      };
      if (orderNo) {
        params = {
          ...params,
          recordNo: orderNo
        };
      }
      if (this.isInvoice) {
        params = {
          ...params,
          type: this.type,
          ...this.form
        };
      }
      return this.$http.post(url, params)
    }
  }
};
</script>

<style lang="stylus" scoped>
.contest-step4 {
  padding: 0 80px 40px;
  font-size: 14px;

  .el-checkbox-group {
    display: inline-block;
    margin-left: 2px;
  }

  .show-list {
    li {
      display: flex;
      flex-direction: row;
      padding: 15px 0;

      .title {
        width: 120px;
        min-width: 120px;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
      }

      div {
        font-size: 14px;

        .xianxia {
          display: block;
          margin-top: 20px;
          border: 1px solid #eaebec;

          p {
            font-weight: 600;
            padding: 20px 80px;
            border-bottom: 1px solid #eaebec;
          }

          .bankList {
            display: flex;
            flex-direction: row;
            padding: 20px 0;

            div {
              flex: 1;
              padding: 0 80px;

              img {
                width: 50%;
                display: block;
              }

              span {
                display: block;
                padding-top: 10px;
                color: #333;
                font-weight: 600;
              }

              &:first-child {
                border-right: 1px solid #eaebec;
              }
            }
          }
        }

        b {
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          color: #D0021B;
          padding-right: 5px;
        }

        span {
          color: #999;
        }
      }
    }
  }

  .notice {
    line-height: 20px;
    color: #999;
  }

  .hasPay {
    text-align: center;

    h4 {
      color: #3664ED;
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      padding: 20px 0;
    }

    p {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }
  }

  .dialog-footer {
    text-align: center;
    padding-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step4.vue